/**
 * Save a file the page made itself (a CSV template, a PDF). Everything happens in
 * the browser: the bytes go from memory to the person's downloads, never over the
 * network.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.rel = 'noopener'
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  link.remove()
  // Revoking at once can cancel the download in some browsers.
  window.setTimeout(() => URL.revokeObjectURL(url), 10_000)
}

/** Save text as a file. CSV gets a byte order mark so spreadsheet apps read it as UTF-8. */
export function downloadText(text: string, filename: string, type = 'text/csv;charset=utf-8'): void {
  const content = type.startsWith('text/csv') ? `﻿${text}` : text
  downloadBlob(new Blob([content], { type }), filename)
}

/** "Chilanga Savers 2026" → "chilanga-savers-2026", for file names. */
export function slugify(text: string): string {
  return text
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 48)
}
